export default "__VITE_ASSET__OJ7NnSxH__"